import { XML_DrawTriPDF } from "./XML_DrawTriPDF";
import { XML_DrawTriPPT } from "./XML_DrawTriPPT";
import { enumXMLType } from "../constants";

export function XML_DrawTri(
  bounds,
  boxShape,
  borderThickness,
  triColor,
  triPosition,
  borderColor,
  dashColor,
  subTriColor,
  drawElement,
  layer
) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF)
    XML_DrawTriPDF(
      bounds,
      boxShape,
      borderThickness,
      triColor,
      triPosition,
      borderColor,
      dashColor,
      subTriColor,
      drawElement,
      layer
    );
  else
    XML_DrawTriPPT(
      bounds,
      boxShape,
      borderThickness,
      triColor,
      triPosition,
      borderColor,
      dashColor,
      subTriColor,
      drawElement,
      layer
    );
}
